import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { can } from '../auth/me';
import { useMe } from '../auth/useMe';
import { formatPln } from '../catalog/money';
import { BARTER_KEY, BARTER_RESOURCE, balanceSide } from './types';
import './barter.css';

/**
 * F43 (spec E3 §6.6): over a subrental, event or rental form — "U <kontrahent> jest nierozliczony barter: <kwota> na
 * naszą korzyść / na ich korzyść" with a link to the contractor in Finanse → Barter. Only with the right to view barter
 * (without it nothing is asked and nothing shown); the amount only to whom may see the balance.
 */
export function BarterWarning({ contractorId, contractorName }: { contractorId: string | null | undefined; contractorName: string }) {
  const { me } = useMe();
  const allowed = !!me && can(me, BARTER_RESOURCE, 'view');
  const balance = useQuery({
    queryKey: [...BARTER_KEY, 'balance', contractorId],
    enabled: allowed && !!contractorId,
    queryFn: () => api<{ open: boolean; balanceGrosze?: number }>(`/api/barter/contractors/${contractorId}/balance`),
  });
  if (!allowed || !contractorId || !balance.data?.open) return null;
  const amount = balance.data.balanceGrosze;
  return (
    <p className="barter-warning" role="status" data-feature-id="barter.warning">
      U {contractorName} jest nierozliczony barter{amount !== undefined ? `: ${formatPln(Math.abs(amount))} ${balanceSide(amount)}` : ''}.{' '}
      <Link to={`/finanse/barter?kontrahent=${contractorId}`}>Zobacz barter</Link>
    </p>
  );
}
